export { };

declare global {
	interface String {
		getStringFromHtml: () => string;
	}
	interface Number {
		toDecimals: (decimals: number) => number;
	}
}
String.prototype.getStringFromHtml = function (): string {
	const div = document.createElement('div');
	div.innerHTML = this.replace(/\n/g, '').replace(/<br(\s+\/)?>/g, '\n').replace(/<\/(p|div)>/g, '</$1>\n');
	return div.textContent ?? div.innerText;
};

Number.prototype.toDecimals = function (decimals: number): number {
	return Math.round(this.valueOf() * Math.pow(10, decimals)) / Math.pow(10, decimals);
}
